import { useEffect, useState } from 'react';

import * as LancamentosAPI from '../../../../../api/lancamentos';

export function useBaixasModule({ uuid, tipo, open, setFlashMessage, onSuccess }) {
    const [itens, setItens] = useState([]);
    const [selectedBaixas, setSelectedBaixas] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [openConfirm, setOpenConfirm] = useState(false);
    const [pendenteEstorno, setPendenteEstorno] = useState([]);

    const fetchData = async () => {
        if (!uuid || !open) {
            setItens([]);
            return;
        }

        setIsLoading(true);

        try {
            const response = await LancamentosAPI.listarBaixas(
                0,
                200,
                JSON.stringify([]),
                JSON.stringify([]),
                '',
                JSON.stringify([]),
                tipo ?? '',
                uuid ?? ''
            );

            setItens(Array.isArray(response?.data?.data) ? response.data.data : []);
        } catch (error) {
            console.error(error);
            setItens([]);
            setFlashMessage?.(
                error?.response?.data?.message || 'Erro ao carregar baixas do lançamento.',
                error?.response?.data?.type || 'error'
            );
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [uuid, tipo, open]);

    const handleEstornarUma = (baixa) => {
        if (!baixa || baixa.estornado === true) return;

        setPendenteEstorno([baixa]);
        setOpenConfirm(true);
    };

    const handleEstornarSelecionadas = () => {
        const selecionadas = itens.filter((item) => selectedBaixas.includes(item.uuid) && item.estornado !== true);

        if (!selecionadas.length) return;

        setPendenteEstorno(selecionadas);
        setOpenConfirm(true);
    };

    const handleConfirmEstorno = async () => {
        if (!pendenteEstorno.length) {
            setOpenConfirm(false);
            return;
        }

        setIsSubmitting(true);

        try {
            const payload = pendenteEstorno.length === 1 ? pendenteEstorno[0] : pendenteEstorno;

            const response = await LancamentosAPI.estornar(payload);

            setFlashMessage?.(response.data.message, response.data.type);

            setSelectedBaixas([]);
            setPendenteEstorno([]);
            setOpenConfirm(false);

            await fetchData();

            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {
            console.error(error);
            setFlashMessage?.(
                error?.response?.data?.message || 'Erro ao estornar baixa.',
                error?.response?.data?.type || 'error'
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    return {
        itens,
        selectedBaixas,
        setSelectedBaixas,

        isLoading,
        isSubmitting,

        openConfirm,
        setOpenConfirm,

        handleConfirmEstorno,
        handleEstornarSelecionadas,
        handleEstornarUma,
        fetchData,
    };
}
